
function AddSale() {
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>New Sale</h5>
                                <br />
                                <div class="live-preview">
                                    <form action="javascript:void(0);">
                                        <div class="row">

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Return No.</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Purchase No." type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Sale Date</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Purchase Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Department</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Department" type="text" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Doctor</label>
                                                    <input id="customername-field" class="form-control" placeholder="Enter Doctor"
                                                        type="date" />
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <br /><br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">

                                                                        <th data-sort="customer_name">Sr. No.</th>
                                                                        <th data-sort="customer_name">Item Name</th>
                                                                        <th data-sort="customer_name">Unit</th>
                                                                        <th data-sort="customer_name">QTY</th>
                                                                        <th data-sort="customer_name">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                    <tr>

                                                                        <td class="customer_name">1.</td>
                                                                        <td class="customer_name">Item 1</td>
                                                                        <td class="customer_name">Unit 1</td>
                                                                        <td class="customer_name">2</td>
                                                                        <td class="customer_name">1080</td>


                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name" colspan="3"></td>
                                                                        <td class="customer_name"><strong>Total Qty</strong></td>
                                                                        <td class="customer_name"><strong>Total Amount</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name" colspan="3"></td>
                                                                        <td class="customer_name"><strong>10</strong></td>
                                                                        <td class="customer_name"><strong>1000</strong></td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddSale;
